import React from 'react';
import { toggleModal } from "../reducers/content";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

const RulesModal = (props) => {
	if(!props.content.showRulesModal)
		return null

	let a = new Date('2020-05-15 12:00:00'),
		b = new Date(),
		diff = (+a - +b);

	return (
		<React.Fragment>
			<div onClick={() => props.toggleModal('rules')} className="the-modal-overlay" />

			<div className="the-modal">
				<div className="fancybox-content">
					<h2 data-selectable="true">Terms & Conditions</h2>
					<div className="text mt-4" data-selectable="true">
						<ul className="num">
							{diff > 0 && <li>The first prize is $5,000 USD for a vacation of your choosing.</li>}
							<li>The scoring algorithm was developed by Cynet. It calculates a score based on the number of correct answers and the time it took to solve each question, starting from the moment you downloaded the question specific files. The timer restarts on the next question and will begin counting down again from the moment you download the next file. You will know your score only after completing all 25 challenges.</li>
							<li>You are limited to one entry. Anyone who enters more than once, will be disqualified.</li>
							<li>The winner will be announced 72 hours after the competition closes. The winner must meet the following requirements:
								<ul>
									<li>Provide their real name and contact details</li>
									<li>Have only participated in the challenge once</li>
									<li>Agree to send a picture of themselves</li>
									<li>Agree to be interviewed</li>
									<li>Agree for Cynet to make use of their photo, real name, and interview in all communication channels including, but not limited to, Cynet’s blog, press releases, email communication, and social media platforms.</li>
								</ul>
							</li>
						</ul>
					</div>

					<div className="text-right mb-3 mb-sm-0">
						<button onClick={() => props.toggleModal('rules')} className="btn-blue_light bold btn-hover text-center sign-up mt-3 ml-auto">GOT IT</button>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

function mapStateToProps(state) {
	return {content: state.content};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	toggleModal
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RulesModal);